// Signaling-WebSocket diagnostics for the PBX softphone (JsSIP).
//
// No custom CRLF keepalive is configured. Registration and transport behavior
// are left at JsSIP defaults, matching the known-working SipService.

/**
 * The live browser WebSocket behind a JsSIP WebSocketInterface, or null.
 */
export function getRawWebSocket(socket) {
    try {
        return socket?.['_ws'] || null;
    } catch (_) {
        return null;
    }
}

/**
 * Logs WebSocket close codes and flags inbound INVITE frames reaching the socket.
 */
export function logWsCloseReason(socket) {
    const ws = getRawWebSocket(socket);
    if (!ws || ws.__diagHooked) {
        return;
    }
    ws.__diagHooked = true;

    ws.addEventListener('message', (event) => {
        if (typeof event.data === 'string' && event.data.startsWith('INVITE ')) {
            console.info('[PBX] INVITE received on raw WebSocket (chan_sip delivered it)');
        }
    });

    const originalOnClose = ws.onclose;
    ws.onclose = function (event) {
        console.warn(
            `SIP WebSocket closed - code=${event.code} reason="${event.reason}" wasClean=${event.wasClean}`
        );
        if (typeof originalOnClose === 'function') {
            originalOnClose.call(this, event);
        }
    };
}
